module.exports = __webpack_public_path__ + "static/media/tmc-footer-logo.91d8955b.png";